// extracted by mini-css-extract-plugin
export default {"close":"GAn4V","closeIcon":"xsmTi"};